/**
 * Custom Local Delivery - Cart orchestrator.
 * Fetches config from planners.dand3.com, validates postal, populates timeslots.
 */
(function () {
  'use strict';

  function isFieldAssociatedWithForm(field, form) {
    if (!field || !form) return false;
    if (field.form && field.form === form) return true;
    var formId = typeof form.getAttribute === 'function' ? form.getAttribute('id') : form.id;
    if (formId && typeof field.getAttribute === 'function' && field.getAttribute('form') === formId) return true;
    return !!(typeof form.contains === 'function' && form.contains(field));
  }

  function isKeyboardSubmitProneField(field, form) {
    if (!field || !form || !isFieldAssociatedWithForm(field, form)) return false;
    var tagName = String(field.tagName || '').toLowerCase();
    if (tagName !== 'input') return false;
    var type = String(field.type || 'text').toLowerCase();
    return !(
      type === 'hidden' ||
      type === 'button' ||
      type === 'submit' ||
      type === 'reset' ||
      type === 'checkbox' ||
      type === 'radio' ||
      type === 'file' ||
      type === 'image'
    );
  }

  function applyNonSubmittingEnterKeyHints(scope) {
    if (!scope || typeof scope.querySelectorAll !== 'function') return;
    var fields = scope.querySelectorAll(
      'input[type="text"], input[type="email"], input[type="tel"], input[type="search"], input[type="url"], input[type="number"], input[type="date"]'
    );
    for (var i = 0; i < fields.length; i++) {
      if (!fields[i] || typeof fields[i].setAttribute !== 'function') continue;
      if (!fields[i].getAttribute || !fields[i].getAttribute('enterkeyhint')) {
        fields[i].setAttribute('enterkeyhint', 'next');
      }
    }
  }

  function bindCartFormKeyboardSubmitGuard(form, scope) {
    if (!form || form.__wfLdKeyboardSubmitGuardBound) return;
    form.__wfLdKeyboardSubmitGuardBound = true;

    var keydownScope = scope && typeof scope.addEventListener === 'function' ? scope : form;
    applyNonSubmittingEnterKeyHints(keydownScope);

    keydownScope.addEventListener('keydown', function (event) {
      if (!event || event.key !== 'Enter') return;
      if (!isKeyboardSubmitProneField(event.target, form)) return;
      event.preventDefault();
    });

    form.addEventListener('submit', function (event) {
      if (!event) return;
      if (event.submitter) return;
      if (!isKeyboardSubmitProneField(document.activeElement, form)) return;
      event.preventDefault();
    });
  }

  function normalizeDeliveryPostal(value) {
    return String(value || '').trim();
  }

  function getDeliveryPostalInput() {
    return document.getElementById('wf-ld-recipient-postal');
  }

  function getDeliveryPostalCodeFromInput(input) {
    return input ? normalizeDeliveryPostal(input.value) : '';
  }

  function isDeliveryAddressGateReady(code, opts) {
    opts = opts || {};
    return String(code || '').trim().length === 6 && !!opts.streetFilled && !!opts.postalValid;
  }

  function normalizeSlotMinute(value) {
    if (value == null || value === '') return 0;
    var parsed = Number(value);
    return isFinite(parsed) ? parsed : 0;
  }

  function slotsShareTimeWindow(a, b) {
    if (!a || !b) return false;
    return Number(a.startHour) === Number(b.startHour) &&
      normalizeSlotMinute(a.startMinute) === normalizeSlotMinute(b.startMinute) &&
      Number(a.endHour) === Number(b.endHour) &&
      normalizeSlotMinute(a.endMinute) === normalizeSlotMinute(b.endMinute);
  }

  function slotsShareAvailableDay(a, b) {
    var aDays = a && Array.isArray(a.availableDays) ? a.availableDays : [];
    var bDays = b && Array.isArray(b.availableDays) ? b.availableDays : [];
    if (!aDays.length || !bDays.length) return true;
    return aDays.some(function (day) { return bDays.indexOf(day) >= 0; });
  }

  function addPricingCandidate(candidates, slotId) {
    var normalized = String(slotId || '').trim();
    if (!normalized || candidates.indexOf(normalized) >= 0) return;
    candidates.push(normalized);
  }

  function resolveMappedPricingTierId(pricing, slotId, slot, defaultSlots) {
    if (!pricing || !pricing.slotTierMap) return '';
    var candidates = [];
    addPricingCandidate(candidates, slotId);
    addPricingCandidate(candidates, slot && slot.pricingSlotId);
    addPricingCandidate(candidates, slot && slot.sourceSlotId);

    var dayMatches = [];
    var timeMatches = [];
    (defaultSlots || []).forEach(function (defaultSlot) {
      if (!slotsShareTimeWindow(slot, defaultSlot)) return;
      if (slotsShareAvailableDay(slot, defaultSlot)) dayMatches.push(defaultSlot);
      else timeMatches.push(defaultSlot);
    });

    dayMatches.concat(timeMatches).forEach(function (defaultSlot) {
      addPricingCandidate(candidates, defaultSlot && defaultSlot.id);
    });

    for (var i = 0; i < candidates.length; i++) {
      var mappedTierId = pricing.slotTierMap[candidates[i]];
      if (mappedTierId) return mappedTierId;
    }
    return '';
  }

  function createInitController(ctx) {
    ctx = ctx || {};
    var deps = ctx.deps || {};

    var API = deps.API || window.WF_LD_API;
    var DATE = deps.DATE || window.WF_LD_DATE_UTILS;
    var POSTAL = deps.POSTAL || window.WF_LD_POSTAL_UTILS;
    var SLOT = deps.SLOT || window.WF_LD_SLOT_UTILS;
    var STORAGE = deps.STORAGE || window.WF_LD_STORAGE;
    var EXPRESS = deps.EXPRESS || window.WF_LD_EXPRESS_CART;
    var PICKER = deps.PICKER || window.WF_LD_DATE_PICKER;
    var ADDRESS_AC = deps.ADDRESS_AC || window.WF_LD_ADDRESS_AC;
    var DOMAIN = deps.DOMAIN || window.WF_LD_CART_DOMAIN;
    var TIMESLOTS = deps.TIMESLOTS || window.WF_LD_CART_TIMESLOTS;
    var CHECKOUT = deps.CHECKOUT || window.WF_LD_CART_CHECKOUT;
    var VALIDATION = deps.VALIDATION || window.WF_LD_CART_VALIDATION;
    var CHECKOUT_FLOW = deps.CHECKOUT_FLOW || window.WF_LD_CART_CHECKOUT_FLOW;
    var UI = deps.UI || window.WF_LD_CART_UI;
    var SAVED = deps.SAVED || window.WF_LD_SAVED_ADDRESSES;

    if (!API || !DATE || !POSTAL || !SLOT || !STORAGE || !EXPRESS || !DOMAIN || !TIMESLOTS || !CHECKOUT || !VALIDATION || !CHECKOUT_FLOW || !UI) {
      console.warn('[wf-ld-init] Missing modules');
      return {
        init: function () {},
        startMixedCartObservers: function () {},
        disposeMixedCartObservers: function () {},
      };
    }

  var config = null;
  var activeTimeslotType = 'standard'; // 'standard' | 'express'
  var seasonalData = null; // { variantWindows: Record<string, [{startDate,endDate,name?,productTitle?}]> }
  var seasonalDataPromise = null;
  var seasonalCheckPending = false;
  var seasonalConflictMessages = [];
  var datePicker = null;
  var dateSelected = false;
  var matchedOccasion = null; // set when cart has an occasion product
  var cartProductIds = [];
  var cartVariantIds = [];
  var advanceBookingRulesResolved = [];
  var activeAdvanceLeadDays = 0;
  var mixedCartObserver = null;
  var mixedCartVisibilityHandler = null;
  var expressSelectionError = '';
  var bootstrapInitGeneration = 0;
  var formInitGeneration = 0;
  var timeslotController = null;
  var validationController = null;
  var checkoutFlowController = null;
  var uiController = null;
  // Controller-scoped handle to the current form session's disposer. The
  // per-node disposer stored on wrap.__wfLdV2Dispose is lost when a silent cart
  // refresh replaces #wf-ld-custom with a freshly-rendered node, so we also keep
  // it here to guarantee the prior session (and its now-detached UI controller)
  // is torn down before re-init. See disposeFormSession use in initForm.
  var activeFormDispose = null;
  var savedAddressController = null;
  var recipientAutocompleteApplying = false;
  var addressConsistencyTimer = null;
  var localPublicConfigResult = null;
  var cartFormTrackingState = {
    started: false,
    identifiedEmail: '',
  };

  function getEl(id) { return document.getElementById(id); }

  function getCurrentTrackingDeliveryMethod() {
    var methodDelivery = getEl('wf-ld-method-delivery');
    if (activeTimeslotType === 'express') return 'Express';
    return (methodDelivery && methodDelivery.checked) ? 'Delivery' : 'Collection';
  }

  function buildCartFormTrackingMeta() {
    return {
      deliveryMethod: getCurrentTrackingDeliveryMethod(),
      senderEmail: getFormVal('sender_email'),
    };
  }

  function trackCartFormProgress() {
    if (!API || typeof API.reportCartFormInteraction !== 'function') return;
    var hasSignal = Boolean(
      getFormVal('recipient_first_name') ||
      getFormVal('recipient_last_name') ||
      getFormVal('recipient_address1') ||
      getFormVal('recipient_postal') ||
      getFormVal('sender_first_name') ||
      getFormVal('sender_last_name') ||
      getFormVal('sender_email') ||
      getFormVal('sender_phone') ||
      getSelectedDateIso() ||
      getActiveTimeslotValue()
    );
    if (hasSignal && !cartFormTrackingState.started) {
      cartFormTrackingState.started = true;
      API.reportCartFormInteraction('form_started', buildCartFormTrackingMeta());
    }

    var senderEmail = String(getFormVal('sender_email') || '').trim().toLowerCase();
    if (senderEmail && cartFormTrackingState.identifiedEmail !== senderEmail) {
      cartFormTrackingState.identifiedEmail = senderEmail;
      API.reportCartFormInteraction('identified', buildCartFormTrackingMeta());
    }
  }

  function normalizeShopifyNumericId(value) {
    return DOMAIN.normalizeShopifyNumericId(value);
  }

  function uniqueCartProductIds(cart) {
    return DOMAIN.uniqueCartProductIds(cart);
  }

  function uniqueCartVariantIds(cart) {
    var items = (cart && cart.items) || [];
    var seen = {};
    var ids = [];
    for (var i = 0; i < items.length; i++) {
      var normalized = normalizeShopifyNumericId(items[i] && items[i].variant_id);
      if (!normalized || seen[normalized]) continue;
      seen[normalized] = true;
      ids.push(normalized);
    }
    return ids;
  }

  function getSeasonalWindowsForVariantId(variantId) {
    if (!seasonalData) return null;
    var normalized = normalizeShopifyNumericId(variantId);
    if (!normalized) return null;
    if (seasonalData[normalized]) return seasonalData[normalized];

    var prefixedNumeric = 'shopify-variant-' + normalized;
    if (seasonalData[prefixedNumeric]) return seasonalData[prefixedNumeric];

    var prefixedGid = 'shopify-variant-gid://shopify/ProductVariant/' + normalized;
    if (seasonalData[prefixedGid]) return seasonalData[prefixedGid];

    var gid = 'gid://shopify/ProductVariant/' + normalized;
    if (seasonalData[gid]) return seasonalData[gid];

    var keys = Object.keys(seasonalData);
    for (var i = 0; i < keys.length; i++) {
      if (normalizeShopifyNumericId(keys[i]) === normalized) return seasonalData[keys[i]];
    }
    return null;
  }

  function isDateAllowedForSeasonalCart(dateIso) {
    if (!dateIso || !seasonalData || !cartVariantIds.length) return true;
    for (var i = 0; i < cartVariantIds.length; i++) {
      var windows = getSeasonalWindowsForVariantId(cartVariantIds[i]);
      if (!windows || !windows.length) continue;
      var withinAny = windows.some(function (window) {
        return dateIso >= window.startDate && dateIso <= window.endDate;
      });
      if (!withinAny) return false;
    }
    return true;
  }

  function collectExpressTierVariantIdsFromConfig(cfg) {
    if (!cfg || !cfg.express_pricing || typeof cfg.express_pricing !== 'object') return [];
    var tiers = Array.isArray(cfg.express_pricing.tiers) ? cfg.express_pricing.tiers : [];
    var seen = {};
    var ids = [];
    tiers.forEach(function (tier) {
      if (!tier || tier.active === false) return;
      var id = String(tier.variantId || '').trim();
      if (!id || seen[id]) return;
      seen[id] = true;
      ids.push(id);
    });
    return ids;
  }

  function formatExpressAmount(amount) {
    if (amount == null || !isFinite(amount)) return null;
    var rounded = Math.round(Number(amount) * 100) / 100;
    if (Math.abs(rounded - Math.round(rounded)) < 0.0001) return String(Math.round(rounded));
    return rounded.toFixed(2).replace(/\.00$/, '');
  }

  function getExpressPricingConfig() {
    if (!config || !config.express_pricing || typeof config.express_pricing !== 'object') return null;
    var tiers = Array.isArray(config.express_pricing.tiers) ? config.express_pricing.tiers : [];
    var slotTierMap = config.express_pricing.slotTierMap && typeof config.express_pricing.slotTierMap === 'object'
      ? config.express_pricing.slotTierMap
      : {};
    var defaultTierId = config.express_pricing.defaultTierId || '';
    return { tiers: tiers, slotTierMap: slotTierMap, defaultTierId: defaultTierId };
  }

  function getDeliveryPricingConfig() {
    if (!config || !config.delivery_pricing || typeof config.delivery_pricing !== 'object') return null;
    var tiers = Array.isArray(config.delivery_pricing.tiers) ? config.delivery_pricing.tiers : [];
    var slotTierMap = config.delivery_pricing.slotTierMap && typeof config.delivery_pricing.slotTierMap === 'object'
      ? config.delivery_pricing.slotTierMap
      : {};
    var defaultTierId = config.delivery_pricing.defaultTierId || '';
    return { tiers: tiers, slotTierMap: slotTierMap, defaultTierId: defaultTierId };
  }

  function getExpressSlotPricingMeta(slotId, slot) {
    var pricing = getExpressPricingConfig();
    if (!pricing) {
      return {
        tierId: '',
        variantId: '',
        amount: null,
      };
    }

    var tierId = resolveMappedPricingTierId(
      pricing,
      slotId,
      slot,
      config && Array.isArray(config.express_timeslots) ? config.express_timeslots : []
    );
    var tier = null;
    if (tierId) {
      tier = pricing.tiers.find(function (t) {
        return t && t.id === tierId && t.active !== false;
      }) || null;
    }
    var variantId = tier && tier.variantId ? String(tier.variantId) : '';
    var amount = tier && isFinite(Number(tier.amount)) ? Number(tier.amount) : null;
    return {
      tierId: tier ? tier.id : '',
      variantId: variantId || '',
      amount: amount,
    };
  }

  function getSelectedExpressSlotMeta() {
    var expSelect = getEl('wf-ld-express-timeslot');
    if (!expSelect || expSelect.selectedIndex < 0) return null;
    var opt = expSelect.options[expSelect.selectedIndex];
    if (!opt || !opt.value) return null;
    var amountAttr = opt.getAttribute('data-amount');
    var parsedAmount = amountAttr != null && amountAttr !== '' ? Number(amountAttr) : null;
    if (parsedAmount != null && !isFinite(parsedAmount)) parsedAmount = null;
    return {
      slotId: opt.getAttribute('data-slot-id') || '',
      tierId: opt.getAttribute('data-tier-id') || '',
      rawLabel: opt.getAttribute('data-raw-label') || opt.value || '',
      amount: parsedAmount,
      variantId: opt.getAttribute('data-variant-id') || '',
    };
  }

  function getSelectedStandardSlotMeta() {
    var stdSelect = getEl('wf-ld-timeslot');
    if (!stdSelect || stdSelect.selectedIndex < 0) return null;
    var opt = stdSelect.options[stdSelect.selectedIndex];
    if (!opt || !opt.value) return null;
    var amountAttr = opt.getAttribute('data-amount');
    var parsedAmount = amountAttr != null && amountAttr !== '' ? Number(amountAttr) : null;
    if (parsedAmount != null && !isFinite(parsedAmount)) parsedAmount = null;
    return {
      slotId: opt.getAttribute('data-slot-id') || '',
      tierId: opt.getAttribute('data-tier-id') || '',
      rawLabel: opt.getAttribute('data-raw-label') || opt.value || '',
      amount: parsedAmount,
      variantId: opt.getAttribute('data-variant-id') || '',
      feeLabel: opt.getAttribute('data-fee-label') || 'Delivery Fee',
    };
  }

  function getStandardSlotPricingMeta(slotId, slot) {
    var pricing = getDeliveryPricingConfig();
    if (!pricing) return { tierId: '', variantId: '', amount: null, hasTierRule: false };
    var tierId = resolveMappedPricingTierId(
      pricing,
      slotId,
      slot,
      config && Array.isArray(config.timeslots) ? config.timeslots : []
    );
    if (!tierId) return { tierId: '', variantId: '', amount: null, hasTierRule: false };
    var tier = pricing.tiers.find(function (t) {
      return t && t.id === tierId && t.active !== false;
    }) || null;
    var variantId = tier && tier.variantId ? String(tier.variantId) : '';
    var amount = tier && isFinite(Number(tier.amount)) ? Number(tier.amount) : null;
    return {
      tierId: tier ? tier.id : tierId,
      variantId: variantId,
      amount: amount,
      hasTierRule: true,
      feeLabel: tier && tier.label ? String(tier.label) : 'Delivery Fee',
    };
  }

  function getActiveTimeslotMeta() {
    if (activeTimeslotType === 'express') return getSelectedExpressSlotMeta();
    return getSelectedStandardSlotMeta();
  }

  function setDeliveryFeeRow(label, amount) {
    if (EXPRESS && typeof EXPRESS.setFeeCharge === 'function') {
      EXPRESS.setFeeCharge(label || 'Delivery Fee', amount);
      return;
    }
    var row = getEl('wf-express-charge-row');
    if (!row) return;
    var labelEl = getEl('wf-delivery-fee-label');
    if (labelEl) labelEl.textContent = label || 'Delivery Fee';
    var moneyEl = row.querySelector('.money');
    if (!moneyEl) return;
    if (amount == null || !isFinite(amount)) {
      moneyEl.textContent = '$0.00';
      return;
    }
    moneyEl.textContent = '$' + Number(amount).toFixed(2);
  }

  function updateExpressCardLabel() {
    var labelEl = getEl('wf-ld-express-label');
    if (!labelEl) return;
    if (activeTimeslotType !== 'express') {
      labelEl.textContent = 'Express';
      return;
    }
    var meta = getSelectedExpressSlotMeta();
    var amountLabel = meta && meta.amount != null ? formatExpressAmount(meta.amount) : null;
    labelEl.textContent = amountLabel ? ('Express (+$' + amountLabel + ')') : 'Express';
  }

  function updateStandardCardLabel() {
    var labelEl = getEl('wf-ld-standard-label');
    if (!labelEl) return;
    if (activeTimeslotType !== 'standard') {
      labelEl.textContent = 'Standard';
      return;
    }
    var meta = getSelectedStandardSlotMeta();
    var amountLabel = meta && meta.amount != null ? formatExpressAmount(meta.amount) : null;
    labelEl.textContent = amountLabel ? ('Standard (+$' + amountLabel + ')') : 'Standard';
  }

  function getCartAttributeField(attrName) {
    var name = 'attributes[' + attrName + ']';
    var form = document.getElementById('cart_form');
    if (form) {
      var hiddenInForm = form.querySelector('input[type="hidden"][name="' + name + '"]');
      if (hiddenInForm) return hiddenInForm;
      var inForm = form.querySelector('[name="' + name + '"]');
      if (inForm) return inForm;
    }
    if (typeof document.querySelector !== 'function') return null;
    var hiddenDetached = document.querySelector('[form="cart_form"][type="hidden"][name="' + name + '"]');
    if (hiddenDetached) return hiddenDetached;
    return document.querySelector('[form="cart_form"][name="' + name + '"]');
  }

  function getFormVal(attrName) {
    var inp = getCartAttributeField(attrName);
    return inp ? inp.value : '';
  }

  function getInputValById(id) {
    var el = getEl(id);
    return el && typeof el.value === 'string' ? el.value.trim() : '';
  }

  function applyCollectionRecipientFallback(recipient, sender) {
    if (!recipient) recipient = {};
    if (!sender) sender = {};

    var collectionName = getInputValById('wf-ld-collection-name');
    var collectionAddress1 = getInputValById('wf-ld-collection-address1');
    var collectionAddress2 = getInputValById('wf-ld-collection-address2');
    var collectionPostal = getInputValById('wf-ld-collection-postal');
    var collectionPhone = getInputValById('wf-ld-collection-phone');

    if (!recipient.firstName) recipient.firstName = collectionName || sender.firstName || 'Self';
    if (!recipient.lastName) recipient.lastName = sender.lastName || 'Collection';
    if (!recipient.phone) recipient.phone = collectionPhone || sender.phone || '';
    if (!recipient.address1) recipient.address1 = collectionAddress1 || '';
    if (!recipient.address2) recipient.address2 = collectionAddress2 || '';
    if (!recipient.postal) recipient.postal = collectionPostal || '';

    return recipient;
  }

  function getPhoneWithCode(inputId, codeId) {
    var code = getEl(codeId);
    var inp = getEl(inputId);
    var prefix = code ? code.value : '+65';
    var raw = inp ? inp.value.trim() : '';
    var num = raw.replace(/\D/g, '');
    if (!num) return '';
    if (raw.charAt(0) === '+') return '+' + num;
    return prefix + num;
  }

  function setPhoneWithCode(inputId, codeId, fullVal) {
    var code = getEl(codeId);
    var inp = getEl(inputId);
    if (fullVal == null) return;
    var raw = String(fullVal).trim();
    if (!raw) {
      if (inp) inp.value = '';
      return;
    }
    if (raw.charAt(0) === '+' && code) {
      var prefix = '';
      var num = '';
      var opts = code.options;
      for (var i = 0; i < opts.length; i++) {
        var optionValue = opts[i].value || '';
        if (optionValue && raw.indexOf(optionValue) === 0 && optionValue.length > prefix.length) {
          prefix = optionValue;
          code.selectedIndex = i;
        }
      }
      if (prefix) {
        num = raw.slice(prefix.length).replace(/\D/g, '');
        if (inp) inp.value = num;
        return;
      }
    }
    if (inp) inp.value = raw;
  }

  function syncPhoneHidden() {
    var rFull = getEl('wf-ld-recipient-phone-full');
    if (rFull) rFull.value = getPhoneWithCode('wf-ld-recipient-phone', 'wf-ld-recipient-phone-code');
    var sFull = getEl('wf-ld-sender-phone-full');
    if (sFull) sFull.value = getPhoneWithCode('wf-ld-sender-phone', 'wf-ld-sender-phone-code');
  }

  function getActiveTimeslotValue() {
    var slotMeta = getActiveTimeslotMeta();
    return slotMeta ? (slotMeta.rawLabel || '') : '';
  }

  function getActiveTimeslotId() {
    var slotMeta = getActiveTimeslotMeta();
    return slotMeta ? (slotMeta.slotId || '') : '';
  }

  function getSelectedDateIso() {
    var dateEl = getEl('wf-ld-date');
    if (!dateEl) return '';
    var fromData = dateEl.getAttribute('data-value') || '';
    if (/^\d{4}-\d{2}-\d{2}$/.test(fromData)) return fromData;
    var fromValue = dateEl.value || '';
    if (/^\d{4}-\d{2}-\d{2}$/.test(fromValue)) return fromValue;
    if (/^\d{2}\/\d{2}\/\d{4}$/.test(fromValue)) {
      var dmy = fromValue.split('/');
      return dmy[2] + '-' + dmy[1] + '-' + dmy[0];
    }
    return '';
  }

  function getDateBounds() {
    return DOMAIN.getDateBounds({
      matchedOccasion: matchedOccasion,
      activeAdvanceLeadDays: activeAdvanceLeadDays,
      config: config,
      DATE: DATE,
    });
  }

  function isDateWithinBounds(dateIso) {
    return DOMAIN.isDateWithinBounds(dateIso, getDateBounds());
  }

  function isDateAllowed(dateIso) {
    return DOMAIN.isDateAllowed(dateIso, getDateBounds(), isBlackoutDate) && isDateAllowedForSeasonalCart(dateIso);
  }

  function isSelectedTimeslotValid() {
    var slotVal = getActiveTimeslotValue();
    if (!slotVal) return false;
    var selectEl = activeTimeslotType === 'express'
      ? getEl('wf-ld-express-timeslot')
      : getEl('wf-ld-timeslot');
    if (!selectEl) return false;
    for (var i = 0; i < selectEl.options.length; i++) {
      var opt = selectEl.options[i];
      if (opt.value === slotVal) return !opt.disabled;
    }
    return false;
  }

  function getResolvedSlotsForActiveMode(dateIso) {
    if (!config || !dateIso) return [];
    var isCollection = !!(getEl('wf-ld-method-collection') && getEl('wf-ld-method-collection').checked);
    var mode = isCollection ? 'collection' : (activeTimeslotType === 'express' ? 'express' : 'delivery');
    var baseSlots = mode === 'collection'
      ? (config.collection_timeslots || [])
      : (mode === 'express' ? (config.express_timeslots || []) : (config.timeslots || []));
    return SLOT.resolveSlotsForDate(baseSlots, dateIso, config.override_days || [], mode);
  }

  function getActiveSlotConfig(dateIso) {
    var iso = dateIso || getSelectedDateIso();
    if (!iso) return null;
    var slotId = getActiveTimeslotId();
    var slotLabel = getActiveTimeslotValue();
    var slots = getResolvedSlotsForActiveMode(iso);
    if (!slots || slots.length === 0) return null;

    if (slotId) {
      for (var i = 0; i < slots.length; i++) {
        if (String(slots[i].id || '') === String(slotId)) return slots[i];
      }
    }
    if (slotLabel) {
      var normalized = String(slotLabel).trim();
      for (var j = 0; j < slots.length; j++) {
        if (String(deriveSlotLabel(slots[j])).trim() === normalized) return slots[j];
      }
    }
    return null;
  }

  function isActiveSlotPastCutoff(dateIso) {
    var iso = dateIso || getSelectedDateIso();
    var slot = getActiveSlotConfig(iso);
    if (!iso || !slot) return false;
    return !!DATE.isPastCutoff(slot, iso);
  }

  function updateAttributes() {
    var form = document.getElementById('cart_form');
    if (!form) return;
    var method = (getEl('wf-ld-method-delivery') && getEl('wf-ld-method-delivery').checked) ? 'Delivery' : 'Collection';
    var dateIso = getSelectedDateIso();
    var slotMeta = getActiveTimeslotMeta();
    var slotLabel = slotMeta ? (slotMeta.rawLabel || '') : '';
    var slotId = slotMeta ? (slotMeta.slotId || '') : '';
    var isExpress = activeTimeslotType === 'express';
    var postal = getDeliveryPostalCodeFromInput(getDeliveryPostalInput());
    var timeVal = dateIso && slotLabel ? dateIso + ' ' + slotLabel : '';

    function setAttr(name, val) {
      var inp = getCartAttributeField(name);
      if (inp) inp.value = val;
    }
    function getAttr(name) {
      return getFormVal(name);
    }
    setAttr('Delivery Method', isExpress ? 'Express' : method);
    setAttr('Local Delivery Date and Time', timeVal); // always set for downstream (notifications, messageCard, email)
    if (method === 'Collection') {
      setAttr('Collection Date and Time', timeVal); // also set for display (avoids "Delivery" wording in Admin)
    } else {
      setAttr('Collection Date and Time', '');
    }
    setAttr('Delivery Area', method === 'Collection' ? '' : (postal || ''));
    setAttr('delivery_date', method === 'Collection' ? '' : (dateIso || ''));
    setAttr('delivery_timeslot', method === 'Collection' ? '' : (slotLabel || ''));
    setAttr('collection_date', method === 'Collection' ? (dateIso || '') : '');
    setAttr('collection_timeslot', method === 'Collection' ? (slotLabel || '') : '');
    setAttr('delivery_slot_id', slotId || '');

    // Anonymous sender
    var anonCb = getEl('wf-ld-anonymous');
    setAttr('sender_anonymous', (anonCb && anonCb.checked) ? 'Yes' : '');

    syncPhoneHidden();
  }

  var postalServerValid = null; // null=pending, true/false=result

  var postalIsHospital = false;

  function isDeliveryStreetFilled() {
    var streetInput = getEl('wf-ld-recipient-address1');
    return !!(streetInput && String(streetInput.value || '').trim());
  }

  function resolveDeliveryPostalValid(code) {
    if (code.length !== 6) return { valid: false, hospital: false };
    if (POSTAL.isHospitalPostal(code)) return { valid: true, hospital: true };
    if (postalServerValid !== null) return { valid: postalServerValid, hospital: false };
    var excludedAreas = config && config.excluded_areas ? config.excluded_areas : [];
    var excludedPrefixes = config && config.excluded_postal_prefixes ? config.excluded_postal_prefixes : [];
    var r = POSTAL.validatePostalClient(code, excludedAreas, excludedPrefixes);
    return { valid: !!(r.valid && !r.excluded), hospital: false };
  }

  function updateAfterPostalVisibility() {
    var addressGate = getEl('wf-ld-address-gate');
    var postalError = getEl('wf-ld-postal-error');
    var hospitalHint = getEl('wf-ld-postal-hospital-hint');
    var afterPostal = getEl('wf-ld-after-postal');
    if (!afterPostal) return;
    var methodDelivery = getEl('wf-ld-method-delivery');
    var isDelivery = methodDelivery && methodDelivery.checked;
    if (addressGate) addressGate.style.display = isDelivery ? 'block' : 'none';
    var postalValid = false;
    postalIsHospital = false;
    var code = '';
    if (isDelivery) {
      var postalInput = getDeliveryPostalInput();
      code = getDeliveryPostalCodeFromInput(postalInput);
      var postalState = resolveDeliveryPostalValid(code);
      postalValid = postalState.valid;
      postalIsHospital = postalState.hospital;
      if (postalError) postalError.style.display = (code.length === 6 && !postalValid && !postalIsHospital) ? 'block' : 'none';
      if (hospitalHint) hospitalHint.style.display = (code.length === 6 && postalIsHospital) ? 'block' : 'none';
    } else {
      postalValid = true;
      if (hospitalHint) hospitalHint.style.display = 'none';
    }
    var gateReady = !isDelivery || isDeliveryAddressGateReady(code, {
      streetFilled: isDeliveryStreetFilled(),
      postalValid: postalValid,
    });
    afterPostal.style.display = gateReady ? 'block' : 'none';
  }

  function validatePostalServer(code) {
    postalServerValid = null;
    updateAfterPostalVisibility();
    if (POSTAL.isHospitalPostal(code)) {
      postalServerValid = true;
      updateAfterPostalVisibility();
      validateAndBlockCheckout();
      return;
    }
    API.fetchValidatePostal(code).then(function (res) {
      if (!res) {
        updateAfterPostalVisibility();
        validateAndBlockCheckout();
        return;
      }
      postalServerValid = res.valid && !res.excluded;
      updateAfterPostalVisibility();
      validateAndBlockCheckout();
    });
  }

  var availabilityData = null;
  function ensureTimeslotController() {
    if (timeslotController) return timeslotController;
    timeslotController = TIMESLOTS.createTimeslotController({
      SLOT: SLOT,
      isPastCutoff: DATE.isPastCutoff,
      fetchAvailability: API.fetchAvailability,
      getConfig: function () { return config; },
      getDateValue: function () {
        var dateEl = getEl('wf-ld-date');
        return dateEl && (dateEl.value || dateEl.getAttribute('data-value'));
      },
      getStandardSelect: function () { return getEl('wf-ld-timeslot'); },
      getExpressSelect: function () { return getEl('wf-ld-express-timeslot'); },
      getMethodCollectionChecked: function () {
        var methodCollection = getEl('wf-ld-method-collection');
        return !!(methodCollection && methodCollection.checked);
      },
      getAvailabilityData: function () { return availabilityData; },
      setAvailabilityData: function (next) { availabilityData = next; },
      getStandardSlotPricingMeta: getStandardSlotPricingMeta,
      getExpressSlotPricingMeta: getExpressSlotPricingMeta,
      formatExpressAmount: formatExpressAmount,
      updateExpressCardLabel: updateExpressCardLabel,
      updateStandardCardLabel: updateStandardCardLabel,
    });
    return timeslotController;
  }

  function deriveSlotLabel(s) {
    return TIMESLOTS.deriveSlotLabel(s);
  }

  function populateTimeslots(dateOverride) {
    ensureTimeslotController().populateTimeslots(dateOverride);
  }

  function fetchAvailabilityAndPopulate(dateVal) {
    return ensureTimeslotController().fetchAvailabilityAndPopulate(dateVal);
  }

  function ensureValidationController() {
    if (validationController) return validationController;
    validationController = VALIDATION.createValidationController({
      deps: {
        POSTAL: POSTAL,
        fetch: fetch,
      },
      dom: {
        getEl: getEl,
        getForm: function () { return document.getElementById('cart_form'); },
      },
      getters: {
        getConfig: function () { return config; },
        getSelectedDateIso: getSelectedDateIso,
        getActiveTimeslotValue: getActiveTimeslotValue,
        isDateAllowed: isDateAllowed,
        isSelectedTimeslotValid: isSelectedTimeslotValid,
        isActiveSlotPastCutoff: isActiveSlotPastCutoff,
        getFormVal: getFormVal,
        getActiveTimeslotType: function () { return activeTimeslotType; },
        getExpressSelectionError: function () { return expressSelectionError; },
        isBlackoutDate: isBlackoutDate,
        getSurchargeForDate: getSurchargeForDate,
        getSeasonalData: function () { return seasonalData; },
        getSeasonalDataPromise: function () { return seasonalDataPromise; },
        getSeasonalCheckPending: function () { return seasonalCheckPending; },
        getSeasonalConflictMessages: function () { return seasonalConflictMessages; },
      },
      setters: {
        setSeasonalCheckPending: function (next) { seasonalCheckPending = !!next; },
        setSeasonalConflictMessages: function (next) {
          seasonalConflictMessages = Array.isArray(next) ? next : [];
        },
      },
    });
    return validationController;
  }

  function ensureCheckoutFlowController() {
    if (checkoutFlowController) return checkoutFlowController;
    checkoutFlowController = CHECKOUT_FLOW.createCheckoutFlowController({
      deps: {
        API: API,
        EXPRESS: EXPRESS,
        STORAGE: STORAGE,
        CHECKOUT: CHECKOUT,
      },
      dom: {
        getEl: getEl,
      },
      getters: {
        getActiveTimeslotValue: getActiveTimeslotValue,
        getActiveTimeslotId: getActiveTimeslotId,
        getActiveTimeslotType: function () { return activeTimeslotType; },
        getExpressSelectionError: function () { return expressSelectionError; },
        getSelectedDateIso: getSelectedDateIso,
        isActiveSlotPastCutoff: isActiveSlotPastCutoff,
        getFormVal: getFormVal,
      },
      actions: {
        runSeasonalConflictCheck: runSeasonalConflictCheck,
        populateTimeslots: populateTimeslots,
        isDateAllowed: isDateAllowed,
        isSelectedTimeslotValid: isSelectedTimeslotValid,
        validateAndBlockCheckout: validateAndBlockCheckout,
        applyCollectionRecipientFallback: applyCollectionRecipientFallback,
        setDeliveryFeeRow: setDeliveryFeeRow,
      },
    });
    return checkoutFlowController;
  }

  function isBlackoutDate(dateStr) {
    if (!config || !config.blackout_dates || !dateStr) return false;
    return config.blackout_dates.some(function (b) { return b.date === dateStr; });
  }

  function getSurchargeForDate(dateStr) {
    if (!config || !config.surcharges || !dateStr) return null;
    for (var i = 0; i < config.surcharges.length; i++) {
      if (config.surcharges[i].date === dateStr) return config.surcharges[i];
    }
    return null;
  }

  function checkSeasonalConflicts(dateStr) {
    return ensureValidationController().checkSeasonalConflicts(dateStr);
  }

  function runSeasonalConflictCheck(dateStr, seasonalHint) {
    return ensureValidationController().runSeasonalConflictCheck(dateStr, seasonalHint);
  }

  function updateDateHints(dateStr) {
    return ensureValidationController().updateDateHints(dateStr);
  }

  function validateAndBlockCheckout() {
    return ensureValidationController().validateAndBlockCheckout();
  }

  var FALLBACK_CONFIG = {
    booking_window: 150,
    timeslots: [
      { id: 'sun-1', label: '11:00 to 15:00', startHour: 11, endHour: 15, cutoffHour: 8, cutoffMinute: 30, availableDays: [0] },
      { id: 'wk-1', label: '10:00 to 14:00', startHour: 10, endHour: 14, cutoffHour: 8, cutoffMinute: 0, availableDays: [1, 2, 3, 4, 5, 6] },
      { id: 'wk-2', label: '14:00 to 18:00', startHour: 14, endHour: 18, cutoffHour: 12, cutoffMinute: 30, availableDays: [1, 2, 3, 4, 5, 6] },
      { id: 'wk-3', label: '18:00 to 22:00', startHour: 18, endHour: 22, cutoffHour: 15, cutoffMinute: 30, availableDays: [1, 2, 3, 4, 5], gated: true },
    ],
    collection_timeslots: [
      { id: 'pickup-mon-sat-am', label: '10:00 to 13:00', startHour: 10, endHour: 13, cutoffHour: 8, cutoffMinute: 0, availableDays: [1, 2, 3, 4, 5, 6] },
      { id: 'pickup-mon-sat-pm', label: '14:00 to 16:00', startHour: 14, endHour: 16, cutoffHour: 14, cutoffMinute: 0, availableDays: [1, 2, 3, 4, 5, 6] },
      { id: 'pickup-sun', label: '11:00 to 16:00', startHour: 11, endHour: 16, cutoffHour: 8, cutoffMinute: 30, availableDays: [0] },
    ],
    blackout_dates: [
      { date: '2027-01-01', reason: 'New Year 2027' },
    ],
    override_days: [
      {
        date: '2026-05-08',
        name: 'MDAY 8 May',
        delivery: {
          slots: [
            { id: 'override-2026-05-08-d-0-1775620625488', label: '10:00 to 14:00', startHour: 10, endHour: 14, cutoffHour: 8, cutoffMinute: 0, availableDays: [5] },
            { id: 'override-2026-05-08-d-1-1775620625488', label: '14:00 to 18:00', startHour: 14, endHour: 18, cutoffHour: 12, cutoffMinute: 30, availableDays: [5] },
          ],
          slotLimits: {},
        },
        collection: {
          slots: [
            { id: 'override-2026-05-08-c-0-1775620625488', label: '10:00 to 16:00', startHour: 10, endHour: 13, endMinute: 0, cutoffHour: 8, cutoffMinute: 0, availableDays: [5] },
            { id: 'override-2026-05-08-c-1-1775620625488', label: '', startHour: 14, endHour: 17, startMinute: 0, endMinute: 0, cutoffHour: 12, cutoffMinute: 30, availableDays: [5] },
          ],
          slotLimits: {},
        },
        express: {
          slots: [
            { id: 'override-2026-05-08-ex-5-1775620625488', label: '16:30 to 17:30', startHour: 16, endHour: 17, startMinute: 30, endMinute: 30, cutoffHour: 15, cutoffMinute: 30, availableDays: [5] },
          ],
          slotLimits: { 'override-2026-05-08-ex-5-1775620625488': 0 },
        },
      },
      {
        date: '2026-05-09',
        name: 'MDAY 9 May',
        delivery: {
          slots: [
            { id: 'override-2026-05-09-d-0-1775621006105', label: '10:00 to 14:00', startHour: 10, endHour: 14, cutoffHour: 8, cutoffMinute: 0, availableDays: [6] },
            { id: 'override-2026-05-09-d-1-1775621006105', label: '14:00 to 18:00', startHour: 14, endHour: 18, cutoffHour: 12, cutoffMinute: 30, availableDays: [6] },
          ],
          slotLimits: {},
        },
        collection: {
          slots: [
            { id: 'override-2026-05-09-c-0-1775621006105', label: '10:00 to 16:00', startHour: 10, endHour: 13, endMinute: 0, cutoffHour: 8, cutoffMinute: 0, availableDays: [6] },
            { id: 'override-2026-05-09-c-1-1775621006105', label: '', startHour: 14, endHour: 17, startMinute: 0, endMinute: 0, cutoffHour: 12, cutoffMinute: 30, availableDays: [6] },
          ],
          slotLimits: {},
        },
        express: {
          slots: [
            { id: 'override-2026-05-09-ex-5-1775621006105', label: '16:30 to 17:30', startHour: 16, endHour: 17, startMinute: 30, endMinute: 30, cutoffHour: 12, cutoffMinute: 30, availableDays: [6] },
          ],
          slotLimits: { 'override-2026-05-09-ex-5-1775621006105': 0 },
        },
      },
      {
        date: '2026-05-10',
        name: 'MDAY 10 May (Sun)',
        delivery: {
          slots: [
            { id: 'override-2026-05-10-d-0-1775620724537', label: '11:00 to 15:00', startHour: 10, endHour: 14, startMinute: 0, endMinute: 0, cutoffHour: 8, cutoffMinute: 0, availableDays: [0] },
            { id: 'override-2026-05-10-d-1775620734480', label: '', startHour: 14, endHour: 18, startMinute: 0, endMinute: 0, cutoffHour: 12, cutoffMinute: 30, availableDays: [0] },
          ],
          slotLimits: {},
        },
        collection: {
          slots: [
            { id: 'override-2026-05-10-c-0-1775620724537', label: '10:00 to 16:00', startHour: 10, endHour: 13, startMinute: 0, endMinute: 0, cutoffHour: 8, cutoffMinute: 0, availableDays: [0] },
            { id: 'override-2026-05-10-c-1775620761119', label: '', startHour: 14, endHour: 17, startMinute: 0, endMinute: 0, cutoffHour: 12, cutoffMinute: 30, availableDays: [0] },
          ],
          slotLimits: {},
        },
        express: {
          slots: [
            { id: 'override-2026-05-10-ex-3-1775620724538', label: '14:30 to 15:30', startHour: 14, endHour: 15, startMinute: 30, endMinute: 30, cutoffHour: 8, cutoffMinute: 30, availableDays: [0] },
          ],
          slotLimits: { 'override-2026-05-10-ex-3-1775620724538': 0 },
        },
      },
      {
        date: '2026-05-11',
        name: 'MDAY 11 May',
        delivery: {
          slots: [
            { id: 'override-2026-05-11-d-0-1775620958231', label: '10:00 to 14:00', startHour: 10, endHour: 14, cutoffHour: 8, cutoffMinute: 0, availableDays: [1] },
            { id: 'override-2026-05-11-d-1-1775620958232', label: '14:00 to 18:00', startHour: 14, endHour: 18, cutoffHour: 12, cutoffMinute: 30, availableDays: [1] },
          ],
          slotLimits: {},
        },
        collection: {
          slots: [
            { id: 'override-2026-05-11-c-0-1775620958232', label: '10:00 to 16:00', startHour: 10, endHour: 13, endMinute: 0, cutoffHour: 8, cutoffMinute: 0, availableDays: [1] },
          ],
          slotLimits: {},
        },
        express: {
          slots: [
            { id: 'override-2026-05-11-ex-5-1775620958232', label: '16:30 to 17:30', startHour: 16, endHour: 17, startMinute: 30, endMinute: 30, cutoffHour: 15, cutoffMinute: 30, availableDays: [1] },
          ],
          slotLimits: { 'override-2026-05-11-ex-5-1775620958232': 0 },
        },
      },
    ],
    excluded_areas: [
      '088762','129817',
      '217562','307677',
      '498746','498747','498781','498783','498784','498793','498801','507087',
      '508487','518230','534236','539747','567754',
      '596303','637900','688251','688255','688262','698930','708976','708977',
      '718916','718923','729756','757619','757629','757754','757758','758534','759959',
      '778895',
    ],
    excluded_postal_prefixes: ['63', '62', '81', '71', '7189'],
    excluded_variants: [],
    occasion_collections: [
      {
        id: 'mother-s-day-2026',
        name: "Mother's Day 2026",
        start_date: '2026-05-08',
        end_date: '2026-05-11',
        collection_url: '/collections/mothers-day',
        disable_express: true,
        active: true,
        product_ids: [
          '8023920869600','8872278720736','8872278950112','8872279179488',
          '8872279671008','8872279834848','8872341897440','8872342651104',
          '8170502095072','8170502848736','9652595556576','9652595589344',
          '9652595622112','9652595654880','9652595687648','9652597752032',
          '9652597850336','7961488425184','9654425878752','9654426534112',
          '9654426829024','9652598079712','9652598046944','9652597981408',
          '9652598014176','9652597883104','9652597817568','9652597915872',
          '9652597948640','9656982012128','9656982569184','9656983584992',
          '8023920279776',
        ],
      },
    ],
  };

  function detectOccasion(cart, occasions) {
    return DOMAIN.detectOccasion(cart, occasions);
  }

  function buildOccasionBlackouts(occasions) {
    return DOMAIN.buildOccasionBlackouts(occasions);
  }

  function getNonOccasionItems(cart, matchedOccasion) {
    return DOMAIN.getNonOccasionItems(cart, matchedOccasion);
  }

  function isMixedCart(cart, matchedOccasion) {
    return DOMAIN.isMixedCart(cart, matchedOccasion);
  }

  function currentAdvanceMethodKey() {
    var methodCollection = getEl('wf-ld-method-collection');
    return DOMAIN.currentAdvanceMethodKey(!!(methodCollection && methodCollection.checked), activeTimeslotType);
  }

  function intersectsAnyProduct(productIds, targetIds) {
    return DOMAIN.intersectsAnyProduct(productIds, targetIds);
  }

  function computeActiveAdvanceLeadDays() {
    return DOMAIN.computeActiveAdvanceLeadDays({
      matchedOccasion: matchedOccasion,
      methodKey: currentAdvanceMethodKey(),
      rules: advanceBookingRulesResolved,
      cartVariantIds: cartVariantIds,
      cartProductIds: cartProductIds,
    });
  }

  function escapeHtml(s) {
    if (!s) return '';
    var div = document.createElement('div');
    div.textContent = s;
    return div.innerHTML;
  }

  function showMixedCartBlock(cart, occ, wrap) {
    var nonOcc = getNonOccasionItems(cart, occ);
    var productNames = nonOcc.map(function (item) { return item.title || 'Item'; });
    var startFmt = DATE.formatDisplayDate(occ.start_date);
    var endFmt = DATE.formatDisplayDate(occ.end_date);
    var methodCollection = getEl('wf-ld-method-collection');
    var fulfilmentWord = methodCollection && methodCollection.checked ? 'collection' : 'delivery';
    var intro = 'Your cart contains both ' + occ.name + ' and regular day items.';
    var proceed = 'To proceed with ' + occ.name + ' ' + fulfilmentWord + ' (' + startFmt + ' to ' + endFmt + '), please remove the regular day items from your cart.';
    var alt = 'Or remove ' + occ.name + ' items to choose a different ' + fulfilmentWord + ' date.';
    var block = getEl('wf-ld-mixed-cart-block');
    if (!block) {
      block = document.createElement('div');
      block.id = 'wf-ld-mixed-cart-block';
      block.className = 'wf-ld-mixed-cart-block';
      var methodCards = wrap.querySelector('.wf-ld-method-cards');
      if (methodCards && methodCards.parentNode) {
        methodCards.parentNode.insertBefore(block, methodCards);
      } else {
        wrap.appendChild(block);
      }
    }
    var removeHtml = '';
    if (productNames.length > 0) {
      removeHtml = '<ul style="margin:8px 0 8px 18px;padding:0;">' +
        productNames.map(function (name) { return '<li>' + escapeHtml(name) + '</li>'; }).join('') +
        '</ul>';
    }
    block.innerHTML =
      '<p style="margin:0 0 8px;">' + escapeHtml(intro) + '</p>' +
      '<p style="margin:0 0 8px;">' + escapeHtml(proceed) + '</p>' +
      (removeHtml ? '<p style="margin:0 0 4px;">Remove:</p>' + removeHtml : '') +
      '<p style="margin:8px 0 8px;">' + escapeHtml(alt) + '</p>' +
      '<a href="/cart" style="font-weight:600;">Edit cart</a>';
    block.style.display = 'block';
  }

  function hideMixedCartBlock() {
    var block = getEl('wf-ld-mixed-cart-block');
    if (block) block.style.display = 'none';
  }

  function initFormDisabled(wrap) {
    wrap.classList.add('wf-ld-form-disabled');
    var form = document.getElementById('cart_form');
    if (form) {
      var btn = form.querySelector('#checkout') || form.querySelector('button[type="submit"]');
      if (btn) btn.disabled = true;
    }
  }

  function clearFormDisabled(wrap) {
    wrap.classList.remove('wf-ld-form-disabled');
    var form = document.getElementById('cart_form');
    if (form) {
      var btn = form.querySelector('#checkout') || form.querySelector('button[type="submit"]');
      if (btn) btn.disabled = false;
    }
  }

  function setBootstrapLoadingState(wrap, message) {
    if (!wrap) return;
    wrap.style.display = '';
    wrap.classList.add('wf-ld-pending');
    initFormDisabled(wrap);
    var hint = getEl('wf-ld-init-hint');
    if (hint) {
      hint.style.display = 'block';
      if (message) hint.textContent = message;
    }
  }

  function clearBootstrapLoadingState(wrap) {
    if (!wrap) return;
    wrap.classList.remove('wf-ld-pending');
    wrap.style.display = '';
    var hint = getEl('wf-ld-init-hint');
    if (hint) hint.style.display = 'none';
  }

  function fetchCartSnapshot() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .catch(function () { return null; });
  }

  function localNowMs() {
    try {
      if (window.performance && typeof window.performance.now === 'function') return window.performance.now();
    } catch (_) {}
    return Date.now();
  }

  function localElapsedSince(startedAt) {
    return Math.max(0, Math.round(localNowMs() - startedAt));
  }

  function describeConfigFetchError(err) {
    if (!err) return 'Unknown fetch error';
    if (err && err.name && err.message) return String(err.name + ': ' + err.message).slice(0, 500);
    if (err && err.message) return String(err.message).slice(0, 500);
    return String(err).slice(0, 500);
  }

  function fetchPublicConfigWithDiagnostics() {
    if (!API || typeof API.fetchPublic !== 'function') return Promise.resolve(null);
    if (typeof API.getLastPublicConfigResult === 'function') return API.fetchPublic();
    if (typeof API.buildDeliveryUrl !== 'function') return API.fetchPublic();

    var url = API.buildDeliveryUrl('/public?_t=' + Date.now());
    var startedAt = localNowMs();
    localPublicConfigResult = { ok: false, reason: 'pending', url: url, elapsedMs: 0 };

    return fetch(url, { credentials: 'omit', cache: 'no-store' })
      .then(function (r) {
        if (!r.ok) {
          return r.text().then(function (text) {
            localPublicConfigResult = {
              ok: false,
              reason: 'http_error',
              statusCode: r.status,
              detail: (text || r.statusText || '').slice(0, 500),
              url: url,
              elapsedMs: localElapsedSince(startedAt),
            };
            return null;
          }).catch(function () {
            localPublicConfigResult = {
              ok: false,
              reason: 'http_error',
              statusCode: r.status,
              detail: r.statusText || '',
              url: url,
              elapsedMs: localElapsedSince(startedAt),
            };
            return null;
          });
        }
        return r.json().then(function (data) {
          localPublicConfigResult = {
            ok: true,
            reason: 'ok',
            statusCode: r.status,
            url: url,
            elapsedMs: localElapsedSince(startedAt),
          };
          return data;
        }).catch(function (err) {
          localPublicConfigResult = {
            ok: false,
            reason: 'json_parse_error',
            statusCode: r.status,
            detail: describeConfigFetchError(err),
            url: url,
            elapsedMs: localElapsedSince(startedAt),
          };
          return null;
        });
      })
      .catch(function (err) {
        localPublicConfigResult = {
          ok: false,
          reason: 'fetch_error',
          detail: describeConfigFetchError(err),
          url: url,
          elapsedMs: localElapsedSince(startedAt),
        };
        return null;
      });
  }

  function reportConfigLoadFailed(reason, err) {
    if (!API || typeof API.reportEvent !== 'function') return;
    var meta = { reason: reason || 'unknown' };
    if (API && typeof API.getLastPublicConfigResult === 'function') {
      var result = API.getLastPublicConfigResult();
      if (result) {
        meta.reason = result.reason || meta.reason;
        if (typeof result.statusCode !== 'undefined') meta.statusCode = result.statusCode;
        if (typeof result.elapsedMs !== 'undefined') meta.elapsedMs = result.elapsedMs;
        if (result.url) meta.configUrl = result.url;
        if (result.detail) meta.detail = result.detail;
      }
    }
    if ((!API || typeof API.getLastPublicConfigResult !== 'function') && localPublicConfigResult) {
      meta.reason = localPublicConfigResult.reason || meta.reason;
      if (typeof localPublicConfigResult.statusCode !== 'undefined') meta.statusCode = localPublicConfigResult.statusCode;
      if (typeof localPublicConfigResult.elapsedMs !== 'undefined') meta.elapsedMs = localPublicConfigResult.elapsedMs;
      if (localPublicConfigResult.url) meta.configUrl = localPublicConfigResult.url;
      if (localPublicConfigResult.detail) meta.detail = localPublicConfigResult.detail;
    }
    if (err && !meta.detail) {
      meta.detail = err && err.message ? err.message : String(err);
    }
    API.reportEvent('config_load_failed', meta);
  }

  function submitCartFormToNativeCheckout() {
    var form = document.getElementById('cart_form');
    if (!form) {
      window.location.href = '/checkout';
      return;
    }
    var checkoutInput = form.querySelector('input[name="checkout"]');
    if (!checkoutInput) {
      checkoutInput = document.createElement('input');
      checkoutInput.type = 'hidden';
      checkoutInput.name = 'checkout';
      checkoutInput.value = 'Checkout';
      form.appendChild(checkoutInput);
    }
    form.submit();
  }

  function clearBypassCheckoutHandler() {
    var btn = getEl('wf-ld-checkout');
    if (!btn || !btn.__wfLdBypassHandler) return;
    btn.removeEventListener('click', btn.__wfLdBypassHandler);
    btn.__wfLdBypassHandler = null;
    btn.removeAttribute('data-wf-ld-checkout-mode');
  }

  function attachBypassCheckoutHandler(reason) {
    var btn = getEl('wf-ld-checkout');
    if (!btn) return;
    clearBypassCheckoutHandler();
    var hint = getEl('wf-ld-checkout-hint');
    if (hint) hint.style.display = 'none';
    btn.disabled = false;
    btn.__wfLdBypassHandler = function (event) {
      event.preventDefault();
      btn.disabled = true;
      btn.textContent = 'Processing...';
      submitCartFormToNativeCheckout();
    };
    btn.addEventListener('click', btn.__wfLdBypassHandler);
    btn.setAttribute('data-wf-ld-checkout-mode', reason || 'native-bypass');
  }

  function buildExcludedIdSets(excludedProducts, excludedVariants) {
    var excSet = {};
    var excVariantSet = {};
    (excludedProducts || []).forEach(function (id) {
      var normalized = normalizeShopifyNumericId(id);
      if (normalized) excSet[normalized] = true;
    });
    (excludedVariants || []).forEach(function (id) {
      var normalized = normalizeShopifyNumericId(id);
      if (normalized) excVariantSet[normalized] = true;
    });
    return { productSet: excSet, variantSet: excVariantSet };
  }

  function isAutoBypassCartItem(item) {
    var productType = String((item && (item.product_type || item.productType)) || '').trim().toLowerCase();
    if (productType === 'mws_apo_generated') return true;
    var handle = String((item && item.handle) || '').trim().toLowerCase();
    if (handle.indexOf('mws_apo_') === 0) return true;
    return false;
  }

  function isExcludedByConfig(item, excludedSets) {
    if (!item || !excludedSets) return false;
    var productCandidates = [
      item.product_id,
      item.productId,
      item.product && item.product.id,
    ];
    var variantCandidates = [
      item.variant_id,
      item.id,
      item.variantId,
      item.variant && item.variant.id,
    ];
    var productExcluded = productCandidates.some(function (candidate) {
      var normalized = normalizeShopifyNumericId(candidate);
      return normalized && excludedSets.productSet[normalized];
    });
    var variantExcluded = variantCandidates.some(function (candidate) {
      var normalized = normalizeShopifyNumericId(candidate);
      return normalized && excludedSets.variantSet[normalized];
    });
    return productExcluded || variantExcluded;
  }

  function shouldBypassDeliveryForm(cart, excludedSets) {
    var items = (cart && cart.items) || [];
    if (items.length === 0) return false;
    var bypassCount = 0;
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (isAutoBypassCartItem(item) || isExcludedByConfig(item, excludedSets)) {
        bypassCount += 1;
      }
    }
    return bypassCount === items.length;
  }

  function debounce(fn, ms) {
    var t = null;
    return function () {
      if (t) clearTimeout(t);
      t = setTimeout(function () { t = null; fn(); }, ms);
    };
  }

  function disposeFormSession(wrap) {
    if (!wrap || typeof wrap.__wfLdV2Dispose !== 'function') return;
    try {
      wrap.__wfLdV2Dispose();
    } catch (err) {
      console.warn('[wf-ld-v2] dispose failed', err);
    }
    wrap.__wfLdV2Dispose = null;
  }

  function checkMixedCartAndReenable(wrap) {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        cartVariantIds = uniqueCartVariantIds(cart);
        var occ = detectOccasion(cart, config.occasion_collections || []);
        if (!occ || !isMixedCart(cart, occ)) {
          if (mixedCartObserver) {
            mixedCartObserver.disconnect();
            mixedCartObserver = null;
          }
          if (mixedCartVisibilityHandler) {
            document.removeEventListener('visibilitychange', mixedCartVisibilityHandler);
            mixedCartVisibilityHandler = null;
          }
          hideMixedCartBlock();
          clearFormDisabled(wrap);
          matchedOccasion = occ;
          disposeFormSession(wrap);
          initForm(wrap);
          console.log('[wf-ld] Mixed cart cleared — form enabled');
        }
      })
      .catch(function () {});
  }

  function startMixedCartObservers(wrap) {
    if (mixedCartObserver || mixedCartVisibilityHandler) return;
    var debouncedCheck = debounce(function () { checkMixedCartAndReenable(wrap); }, 300);

    var target = document.querySelector('.cart__item-list') || document.querySelector('.cart__form');
    if (target) {
      mixedCartObserver = new MutationObserver(function () { debouncedCheck(); });
      mixedCartObserver.observe(target, { childList: true, subtree: true });
    }

    mixedCartVisibilityHandler = function () {
      if (document.visibilityState === 'visible') debouncedCheck();
    };
    document.addEventListener('visibilitychange', mixedCartVisibilityHandler);
  }

  function isCurrentBootstrap(bootstrapRunId, wrap) {
    return bootstrapRunId === bootstrapInitGeneration && document.getElementById('wf-ld-custom') === wrap;
  }

  function init() {
    var wrap = document.getElementById('wf-ld-custom');
    if (!wrap) return;
    bootstrapInitGeneration += 1;
    var bootstrapRunId = bootstrapInitGeneration;
    setBootstrapLoadingState(wrap, 'Loading delivery options...');

    function revealWrap() {
      clearBootstrapLoadingState(wrap);
    }

    Promise.all([fetchPublicConfigWithDiagnostics(), fetchCartSnapshot()]).then(function (results) {
      if (!isCurrentBootstrap(bootstrapRunId, wrap)) return;
      var c = results[0];
      var cart = results[1];
      config = c;
      if (!config) {
        config = FALLBACK_CONFIG;
        console.warn('[wf-ld] Using fallback config (API unavailable)');
        reportConfigLoadFailed('public_config_unavailable');
      }
      try {
        var storeKey = API && typeof API.getStoreKey === 'function'
          ? API.getStoreKey()
          : ((window.WF_LD_RUNTIME && window.WF_LD_RUNTIME.storeKey) || 'WF');
        var tierVariantIds = collectExpressTierVariantIdsFromConfig(config);
        window.WF_LD_DEBUG_STATE = window.WF_LD_DEBUG_STATE || {};
        window.WF_LD_DEBUG_STATE.delivery = {
          orchestrator: (window.WF_LD_RUNTIME && window.WF_LD_RUNTIME.cartOrchestrator) || 'v1',
          storeKey: storeKey,
          expressVariantFallback: String(config.express_product_variant_id || ''),
          expressTierVariantIds: tierVariantIds,
          loadedAtIso: new Date().toISOString(),
        };
        console.info('[wf-ld][linkage] loaded public config', window.WF_LD_DEBUG_STATE.delivery);
      } catch (err) {}

      var excludedProducts = config.excluded_products || [];
      var excludedVariants = config.excluded_variants || [];
      if (window.WF_CART_LINE_MESSAGES && typeof window.WF_CART_LINE_MESSAGES.initMessageCards === 'function') {
        var messageCardConfig = config.message_card_config || {};
        if (messageCardConfig && typeof messageCardConfig === 'object') {
          var messageExcludedProducts = Array.isArray(messageCardConfig.excludedProductIds)
            ? messageCardConfig.excludedProductIds.map(String)
            : [];
          var mergedExcludedProducts = {};
          messageExcludedProducts.concat(excludedProducts || []).forEach(function (id) {
            var key = String(id || '').trim();
            if (key) mergedExcludedProducts[key] = true;
          });
          messageCardConfig = {
            enabled: messageCardConfig.enabled,
            propertyName: messageCardConfig.propertyName,
            excludedProductIds: Object.keys(mergedExcludedProducts),
            excludedVariantIds: Array.isArray(excludedVariants) ? excludedVariants.map(String) : [],
          };
        }
        window.WF_CART_LINE_MESSAGES.initMessageCards(messageCardConfig);
      }
      var occasions = config.occasion_collections || [];
      advanceBookingRulesResolved = Array.isArray(config.advance_booking_rules_resolved)
        ? config.advance_booking_rules_resolved
        : [];
      if (!cart) {
        cartProductIds = [];
        cartVariantIds = [];
        clearBypassCheckoutHandler();
        revealWrap();
        initForm(wrap);
        return;
      }

      cartProductIds = uniqueCartProductIds(cart);
      cartVariantIds = uniqueCartVariantIds(cart);
      var excludedSets = buildExcludedIdSets(excludedProducts, excludedVariants);
      if (shouldBypassDeliveryForm(cart, excludedSets)) {
        clearBootstrapLoadingState(wrap);
        wrap.style.display = 'none';
        attachBypassCheckoutHandler('native-bypass-opt-out');
        console.log('[wf-ld] Delivery form bypassed: cart fully opt-out/APO-generated');
        return;
      }
      clearBypassCheckoutHandler();
      matchedOccasion = detectOccasion(cart, occasions);
      if (matchedOccasion && isMixedCart(cart, matchedOccasion)) {
        revealWrap();
        showMixedCartBlock(cart, matchedOccasion, wrap);
        initFormDisabled(wrap);
        startMixedCartObservers(wrap);
        console.log('[wf-ld] Mixed cart — occasion + regular day items; form blocked');
        return;
      }
      revealWrap();
      initForm(wrap);
    }).catch(function (err) {
      if (!isCurrentBootstrap(bootstrapRunId, wrap)) return;
      config = FALLBACK_CONFIG;
      console.warn('[wf-ld] Using fallback config (bootstrap failed)');
      reportConfigLoadFailed('bootstrap_exception', err);
      cartProductIds = [];
      cartVariantIds = [];
      clearBypassCheckoutHandler();
      revealWrap();
      initForm(wrap);
    });
  }

  function initForm(wrap) {
    clearBootstrapLoadingState(wrap);
    clearFormDisabled(wrap);
    clearBypassCheckoutHandler();
    disposeFormSession(wrap);
    // A silent cart refresh (qty stepper, message save, discount apply, config
    // reload) swaps the cart section's innerHTML, destroying and recreating the
    // #wf-ld-custom node. The disposeFormSession(wrap) call above therefore
    // no-ops — the fresh node carries no __wfLdV2Dispose — leaving the previous
    // UI controller alive but bound to the now-detached wrap. ensureUiController
    // would then return that stale controller and re-bind the Delivery|Express
    // toggle (and method cards) to dead, detached nodes, so clicks do nothing.
    // Dispose via the controller-scoped handle, which survives node replacement.
    if (typeof activeFormDispose === 'function') {
      try { activeFormDispose(); } catch (err) {}
      activeFormDispose = null;
    }
    formInitGeneration += 1;
    var currentGeneration = formInitGeneration;
    var disposers = [];

    function on(el, eventName, handler, options) {
      if (!el || !eventName || !handler) return;
      el.addEventListener(eventName, handler, options);
      disposers.push(function () {
        el.removeEventListener(eventName, handler, options);
      });
    }

    function syncFeeStateAfterTimeslotRefresh(summary) {
      var controller = ensureUiController();
      if (!controller || typeof controller.syncFeeStateAfterTimeslotRefresh !== 'function') {
        return Promise.resolve(false);
      }
      return controller.syncFeeStateAfterTimeslotRefresh(summary);
    }

    function disposeThisForm() {
      if (currentGeneration !== formInitGeneration) return;
      activeFormDispose = null;
      if (uiController && typeof uiController.dispose === 'function') {
        uiController.dispose();
        uiController = null;
      }
      if (datePicker && typeof datePicker.destroy === 'function') {
        datePicker.destroy();
      }
      datePicker = null;
      while (disposers.length > 0) {
        var dispose = disposers.pop();
        try {
          dispose();
        } catch (err) {}
      }
    }

    wrap.__wfLdV2Dispose = disposeThisForm;
    activeFormDispose = disposeThisForm;

    if (window.WF_LD_UPSELL && typeof window.WF_LD_UPSELL.init === 'function') {
      window.WF_LD_UPSELL.init();
    }

    var today = DATE.todayStrSgt();
    var defaultMax = DATE.maxDateStrSgt(config.booking_window || 120);
    var dateInput = getEl('wf-ld-date');

    activeAdvanceLeadDays = computeActiveAdvanceLeadDays();
    var pickerMin = DATE.addDaysStrSgt(activeAdvanceLeadDays || 0);
    var pickerMax = defaultMax;
    var mergedBlackouts = (config.blackout_dates || []).slice();
    var occasions = config.occasion_collections || [];

    function showRestoreWarning(message) {
      if (!message) return;
      var warn = getEl('wf-ld-restore-warning');
      if (!warn) {
        warn = document.createElement('div');
        warn.id = 'wf-ld-restore-warning';
        warn.style.cssText = 'background:#fff3f3;border:1px solid #ffc7c7;border-radius:6px;padding:10px 14px;margin-bottom:12px;font-size:13px;color:#8a1f1f;line-height:1.5;';
        var dateLabel = getEl('wf-ld-date-label');
        if (dateLabel && dateLabel.parentNode) {
          dateLabel.parentNode.insertBefore(warn, dateLabel);
        } else {
          wrap.insertBefore(warn, wrap.firstChild);
        }
      }
      warn.textContent = message;
      warn.style.display = 'block';
    }

    if (matchedOccasion) {
      pickerMin = matchedOccasion.start_date;
      pickerMax = matchedOccasion.end_date;
      console.log('[wf-ld] Occasion mode:', matchedOccasion.name, pickerMin, '→', pickerMax);
    } else if (occasions.length > 0) {
      var occBlackouts = buildOccasionBlackouts(occasions);
      mergedBlackouts = mergedBlackouts.concat(occBlackouts);
    }

    function updateOccasionBannerCopy() {
      if (!matchedOccasion) return;
      var banner = getEl('wf-ld-occasion-banner');
      if (!banner) return;
      var startFmt = DATE.formatDisplayDate(matchedOccasion.start_date);
      var endFmt = DATE.formatDisplayDate(matchedOccasion.end_date);
      var methodCollection = getEl('wf-ld-method-collection');
      var isCollection = methodCollection && methodCollection.checked;
      var modePhrase = isCollection ? 'collection available' : 'delivery available';
      banner.textContent =
        matchedOccasion.name + ' order — ' + modePhrase + ' ' + startFmt + ' to ' + endFmt + ' only';
    }

    // occasion banner
    var occasionBanner = getEl('wf-ld-occasion-banner');
    var advanceBookingBanner = getEl('wf-ld-advance-booking-banner');
    if (matchedOccasion) {
      if (!occasionBanner) {
        occasionBanner = document.createElement('div');
        occasionBanner.id = 'wf-ld-occasion-banner';
        occasionBanner.style.cssText = 'background:#fff8e1;border:1px solid #ffe082;border-radius:6px;padding:10px 14px;margin-bottom:14px;font-size:13px;color:#6d4c00;line-height:1.5;';
        var dateLabel = getEl('wf-ld-date-label');
        if (dateLabel && dateLabel.parentNode) {
          dateLabel.parentNode.insertBefore(occasionBanner, dateLabel);
        }
      }
      updateOccasionBannerCopy();
      occasionBanner.style.display = 'block';
    } else if (occasionBanner) {
      occasionBanner.style.display = 'none';
    }
    if (!advanceBookingBanner) {
      advanceBookingBanner = document.createElement('div');
      advanceBookingBanner.id = 'wf-ld-advance-booking-banner';
      advanceBookingBanner.style.cssText = 'background:#f3f8ff;border:1px solid #b8d7ff;border-radius:6px;padding:10px 14px;margin-bottom:14px;font-size:13px;color:#194a8d;line-height:1.5;display:none;';
      var dateLabelForAdvance = getEl('wf-ld-date-label');
      if (dateLabelForAdvance && dateLabelForAdvance.parentNode) {
        dateLabelForAdvance.parentNode.insertBefore(advanceBookingBanner, dateLabelForAdvance);
      }
    }

    function resetDateAndTimeslotSelection(showHintMessage) {
      if (datePicker && datePicker.setValue) {
        datePicker.setValue('');
      } else if (dateInput) {
        dateInput.value = '';
        dateInput.setAttribute('data-value', '');
      }
      dateSelected = false;
      var std = getEl('wf-ld-timeslot');
      var exp = getEl('wf-ld-express-timeslot');
      if (std) std.value = '';
      if (exp) exp.value = '';
      updateDateHints('');
      populateTimeslots();
      updateTimeslotLockState();
      if (showHintMessage) {
        var checkoutHint = getEl('wf-ld-checkout-hint');
        if (checkoutHint) {
          checkoutHint.textContent = showHintMessage;
          checkoutHint.style.display = 'block';
        }
      }
    }

    function updateAdvanceBookingBanner() {
      if (!advanceBookingBanner) return;
      if (matchedOccasion || activeAdvanceLeadDays <= 0) {
        advanceBookingBanner.style.display = 'none';
        return;
      }
      var earliestIso = DATE.addDaysStrSgt(activeAdvanceLeadDays);
      var earliestFmt = DATE.formatDisplayDate(earliestIso);
      advanceBookingBanner.textContent =
        'Earliest available date is ' + earliestFmt + ' due to advance booking requirements.';
      advanceBookingBanner.style.display = 'block';
    }

    function isDateDisabledForPicker(iso) {
      if (!isDateAllowed(iso)) return true;
      var collEl = getEl('wf-ld-method-collection');
      var isColl = collEl && collEl.checked;
      var mode = isColl ? 'collection' : 'delivery';
      var stdSlots = isColl ? (config.collection_timeslots || []) : config.timeslots;
      var overrides = config.override_days || [];
      var stdAvail = SLOT.filterAvailableSlots(stdSlots, iso, config.blackout_dates, DATE.isPastCutoff, overrides, mode);
      if (stdAvail.length > 0) return false;
      if (!isColl && config.express_timeslots && config.express_timeslots.length > 0) {
        var expAvail = SLOT.filterAvailableSlots(
          config.express_timeslots,
          iso,
          config.blackout_dates,
          DATE.isPastCutoff,
          overrides,
          'express'
        );
        if (expAvail.length > 0) return false;
      }
      return true;
    }

    function applyDynamicDateBounds() {
      var bounds = getDateBounds();
      if (datePicker && datePicker.updateOpts) {
        datePicker.updateOpts({ minDate: bounds.min, maxDate: bounds.max });
      } else if (dateInput) {
        dateInput.setAttribute('min', bounds.min);
        dateInput.setAttribute('max', bounds.max);
      }
      updateAdvanceBookingBanner();
      var selectedIso = getSelectedDateIso();
      if (selectedIso && !isDateAllowed(selectedIso)) {
        resetDateAndTimeslotSelection(
          'Selected date is no longer valid due to advance booking requirements. Please choose another date.',
        );
      }
    }

    if (dateInput && PICKER) {
      datePicker = PICKER.attach(dateInput, {
        minDate: pickerMin,
        maxDate: pickerMax,
        blackoutDates: mergedBlackouts,
        surcharges: config.surcharges || [],
        overrideDays: config.override_days || [],
        isDateDisabled: isDateDisabledForPicker,
        onSelect: function (iso) {
          dateInput.setAttribute('data-value', iso);
          dateSelected = true;
          updateDateHints(iso);
          Promise.resolve(fetchAvailabilityAndPopulate(iso)).then(function (summary) {
            return syncFeeStateAfterTimeslotRefresh(summary);
          });
          updateTimeslotLockState();
          onChange();
        },
      });

      if (matchedOccasion) {
        var startParts = matchedOccasion.start_date.split('-');
        datePicker.navigateToMonth(parseInt(startParts[0], 10), parseInt(startParts[1], 10) - 1);
      }
    } else if (dateInput) {
      dateInput.setAttribute('min', pickerMin);
      dateInput.setAttribute('max', pickerMax);
    }
    applyDynamicDateBounds();

    seasonalDataPromise = API.fetchSeasonal()
      .then(function (data) {
        seasonalData = (data && data.variantWindows) ? data.variantWindows : null;
      })
      .catch(function () {
        seasonalData = null;
      });
    seasonalDataPromise.then(function () {
      if (datePicker && typeof datePicker.updateOpts === 'function') {
        datePicker.updateOpts({ isDateDisabled: isDateDisabledForPicker });
      }
      var selectedDate = getSelectedDateIso();
      if (selectedDate && !isDateAllowedForSeasonalCart(selectedDate)) {
        resetDateAndTimeslotSelection(
          'Selected date is outside the allowed seasonal delivery window. Please choose another date.',
        );
        return;
      }
      if (selectedDate) updateDateHints(selectedDate);
    });

    var methodDelivery = getEl('wf-ld-method-delivery');
    var methodCollection = getEl('wf-ld-method-collection');
    function updateRecipientAddressSummary() {
      var summary = getEl('wf-ld-recipient-address-summary');
      if (!summary) return;
      var addr1 = String(getFormVal('recipient_address1') || '').trim();
      var addr2 = String(getFormVal('recipient_address2') || '').trim();
      var postal = getDeliveryPostalCodeFromInput(getDeliveryPostalInput());
      var parts = [];
      if (addr1) parts.push(addr1);
      if (addr2) parts.push(addr2);
      if (postal) parts.push(postal);
      summary.textContent = parts.join(', ');
      summary.style.display = parts.length ? 'block' : 'none';
    }

    function collectState() {
      var anonCb = getEl('wf-ld-anonymous');
      return {
        method: (methodDelivery && methodDelivery.checked) ? 'delivery' : 'collection',
        postal: getDeliveryPostalCodeFromInput(getDeliveryPostalInput()),
        rFirstName: getFormVal('recipient_first_name'),
        rLastName: getFormVal('recipient_last_name'),
        rPhone: getPhoneWithCode('wf-ld-recipient-phone', 'wf-ld-recipient-phone-code'),
        rAddr1: getFormVal('recipient_address1'),
        rAddr2: getFormVal('recipient_address2'),
        rPostal: getFormVal('recipient_postal'),
        sFirstName: getFormVal('sender_first_name'),
        sLastName: getFormVal('sender_last_name'),
        sEmail: getFormVal('sender_email'),
        sPhone: getPhoneWithCode('wf-ld-sender-phone', 'wf-ld-sender-phone-code'),
        anonymous: anonCb ? anonCb.checked : false,
        stateVersion: 2,
      };
    }

    function onChange() {
      updateAttributes();
      updateAfterPostalVisibility();
      updateRecipientAddressSummary();
      populateTimeslots();
      validateAndBlockCheckout();
      STORAGE.save(collectState());
      trackCartFormProgress();
    }

    function setFormVal(attrName, val) {
      if (val == null) return;
      var inp = getCartAttributeField(attrName);
      if (inp) inp.value = val;
    }

    function clearAddressConsistencyHint() {
      var hint = getEl('wf-ld-address-consistency-hint');
      if (!hint) return;
      hint.textContent = '';
      hint.style.display = 'none';
    }

    function showAddressConsistencyHint(message) {
      if (!message) return;
      var hint = getEl('wf-ld-address-consistency-hint');
      if (!hint) return;
      hint.textContent = message;
      hint.style.display = 'block';
    }

    function buildAddressConsistencyMismatchMessage(street, enteredPostal, suggestedPostal) {
      return (
        'Postal code ' +
        enteredPostal +
        ' does not match ' +
        street +
        '. Google Maps suggests ' +
        suggestedPostal +
        ' for this street. Update the street or pick a postal suggestion.'
      );
    }

    function runAddressConsistencyCheck(done) {
      done = typeof done === 'function' ? done : function () {};
      if (recipientAutocompleteApplying) {
        done(null);
        return;
      }
      if (!ADDRESS_AC || typeof ADDRESS_AC.verifyStreetPostalConsistency !== 'function') {
        done(null);
        return;
      }
      var street = getFormVal('recipient_address1');
      var postal = getFormVal('recipient_postal');
      if (!String(street || '').trim() || String(postal || '').trim().length !== 6) {
        clearAddressConsistencyHint();
        done(null);
        return;
      }
      ADDRESS_AC.verifyStreetPostalConsistency(street, postal, function (result) {
        if (!result || result.status === 'match' || result.status === 'skipped' || result.status === 'unavailable') {
          clearAddressConsistencyHint();
          done(null);
          return;
        }
        if (result.status === 'mismatch') {
          showAddressConsistencyHint(
            buildAddressConsistencyMismatchMessage(street, result.enteredPostal, result.suggestedPostal)
          );
          done(result);
          return;
        }
        done(null);
      });
    }

    function ensureAddressConsistencyBeforeCheckout(done) {
      done = typeof done === 'function' ? done : function () {};
      if (!methodDelivery || !methodDelivery.checked) {
        done(true);
        return;
      }
      var active = document.activeElement;
      if (
        active &&
        typeof active.blur === 'function' &&
        (active.name === 'attributes[recipient_address1]' || active.name === 'attributes[recipient_postal]')
      ) {
        active.blur();
      }
      runAddressConsistencyCheck(function (result) {
        if (result && result.status === 'mismatch') {
          validateAndBlockCheckout();
          done(false);
          return;
        }
        done(true);
      });
    }

    function scheduleAddressConsistencyCheck() {
      if (recipientAutocompleteApplying) return;
      if (addressConsistencyTimer) clearTimeout(addressConsistencyTimer);
      addressConsistencyTimer = setTimeout(function () {
        addressConsistencyTimer = null;
        runAddressConsistencyCheck();
      }, 400);
    }

    function showSavedAddressMismatchHint(enteredPostal, suggestedPostal) {
      showAddressConsistencyHint(
        'This saved address may be outdated. Google Maps suggests postal code ' +
        suggestedPostal +
        ' for this street (your saved address has ' +
        enteredPostal +
        '). Please double-check before checkout.'
      );
    }

    function verifySavedRecipientAddressPostal(savedAddress) {
      if (!ADDRESS_AC || typeof ADDRESS_AC.verifySavedAddressPostalMatch !== 'function') return;
      ADDRESS_AC.verifySavedAddressPostalMatch(savedAddress, function (result) {
        if (!result || result.status !== 'mismatch') return;
        showSavedAddressMismatchHint(result.enteredPostal, result.suggestedPostal);
      });
    }

    function applySavedRecipientAddress(savedAddress) {
      if (!savedAddress) return;
      clearAddressConsistencyHint();
      var postal = String(savedAddress.zip || '').trim();
      setFormVal('recipient_first_name', savedAddress.firstName || '');
      setFormVal('recipient_last_name', savedAddress.lastName || '');
      setPhoneWithCode('wf-ld-recipient-phone', 'wf-ld-recipient-phone-code', savedAddress.phone || '');
      setFormVal('recipient_address1', savedAddress.address1 || '');
      setFormVal('recipient_address2', savedAddress.address2 || '');
      setFormVal('recipient_postal', postal);
      syncPhoneHidden();
      if (postal.length === 6) {
        validatePostalServer(postal);
      }
      verifySavedRecipientAddressPostal(savedAddress);
      onChange();
    }

    function restoreState() {
      var s = STORAGE.load();
      if (!s) return;
      var hadPersistedSensitiveValues = !!(s.dateIso || s.stdSlot || s.expSlot || s.dateDisplay || s.timeslotType);
      // Delivery is the storefront default. Do not let stale localStorage from a
      // prior cart/session make Self-collection the default on a fresh load.
      if (methodDelivery) {
        methodDelivery.checked = true;
      }
      if (methodCollection) methodCollection.checked = false;
      setFormVal('recipient_first_name', s.rFirstName);
      setFormVal('recipient_last_name', s.rLastName);
      setPhoneWithCode('wf-ld-recipient-phone', 'wf-ld-recipient-phone-code', s.rPhone);
      setFormVal('recipient_address1', s.rAddr1);
      setFormVal('recipient_address2', s.rAddr2);
      setFormVal('recipient_postal', s.rPostal || s.postal || '');
      setFormVal('sender_first_name', s.sFirstName);
      setFormVal('sender_last_name', s.sLastName);
      setFormVal('sender_email', s.sEmail);
      setPhoneWithCode('wf-ld-sender-phone', 'wf-ld-sender-phone-code', s.sPhone);
      var anonCb = getEl('wf-ld-anonymous');
      if (anonCb && s.anonymous) anonCb.checked = true;

      var restoredPostal = String(s.rPostal || s.postal || '').trim();
      if (restoredPostal.length === 6) validatePostalServer(restoredPostal);
      if (hadPersistedSensitiveValues) {
        showRestoreWarning('Your previously saved date/timeslot was cleared. Please reselect delivery date and timeslot to use latest availability.');
      }

      STORAGE.save(collectState());
      trackCartFormProgress();

      return s;
    }

    var recipientBlock = getEl('wf-ld-recipient-block');
    var pickupAddressBlock = getEl('wf-ld-pickup-address');
    var dateLabelEl = getEl('wf-ld-date-label');

    function updateMethodDependentUI() {
      var isDelivery = methodDelivery && methodDelivery.checked;
      if (recipientBlock) recipientBlock.style.display = isDelivery ? 'block' : 'none';
      if (pickupAddressBlock) pickupAddressBlock.style.display = isDelivery ? 'none' : 'block';
      if (dateLabelEl) dateLabelEl.textContent = isDelivery ? 'Delivery date' : 'Collection date';
      if (datePicker && datePicker.updateOpts) {
        datePicker.updateOpts({
          displayPlaceholder: isDelivery ? 'Select delivery date' : 'Select collection date',
        });
      }
      updateOccasionBannerCopy();
    }
    function updateRecipientVisibility() { updateMethodDependentUI(); }

    function ensureUiController() {
      if (uiController) return uiController;
      uiController = UI.createUiController({
        deps: {
          EXPRESS: EXPRESS,
          STORAGE: STORAGE,
        },
        dom: {
          getEl: getEl,
          wrap: wrap,
        },
        getters: {
          getConfig: function () { return config; },
          getMatchedOccasion: function () { return matchedOccasion; },
          getDatePicker: function () { return datePicker; },
          getDateSelected: function () { return dateSelected; },
          getActiveTimeslotType: function () { return activeTimeslotType; },
          getActiveAdvanceLeadDays: function () { return activeAdvanceLeadDays; },
          getExpressSelectionError: function () { return expressSelectionError; },
        },
        setters: {
          setDateSelected: function (next) { dateSelected = !!next; },
          setActiveTimeslotType: function (next) { activeTimeslotType = next; },
          setActiveAdvanceLeadDays: function (next) { activeAdvanceLeadDays = next || 0; },
          setExpressSelectionError: function (next) { expressSelectionError = next || ''; },
        },
        actions: {
          updateExpressCardLabel: updateExpressCardLabel,
          updateStandardCardLabel: updateStandardCardLabel,
          validateAndBlockCheckout: validateAndBlockCheckout,
          populateTimeslots: populateTimeslots,
          fetchAvailabilityAndPopulate: fetchAvailabilityAndPopulate,
          updateDateHints: updateDateHints,
          onChange: onChange,
          updateRecipientVisibility: updateRecipientVisibility,
          collectState: collectState,
          setDeliveryFeeRow: setDeliveryFeeRow,
          computeActiveAdvanceLeadDays: computeActiveAdvanceLeadDays,
          applyDynamicDateBounds: applyDynamicDateBounds,
          getSelectedExpressSlotMeta: getSelectedExpressSlotMeta,
          getSelectedStandardSlotMeta: getSelectedStandardSlotMeta,
          setPostalServerValid: function (next) { postalServerValid = next; },
          validatePostalServer: validatePostalServer,
          syncPhoneHidden: syncPhoneHidden,
          updateAttributes: updateAttributes,
          clearAddressConsistencyHint: clearAddressConsistencyHint,
          scheduleAddressConsistencyCheck: scheduleAddressConsistencyCheck,
          isRecipientAutocompleteApplying: function () { return recipientAutocompleteApplying; },
        },
      });
      return uiController;
    }

    function updateTimeslotTypeVisibility() {
      ensureUiController().updateTimeslotTypeVisibility();
    }

    function refreshAdvanceBookingState() {
      ensureUiController().refreshAdvanceBookingState();
    }

    function updateTimeslotLockState() {
      ensureUiController().updateTimeslotLockState();
    }

    function ensureSavedAddressController() {
      if (savedAddressController) return savedAddressController;
      if (!SAVED || typeof SAVED.createSavedAddressController !== 'function') return null;
      savedAddressController = SAVED.createSavedAddressController({
        document: document,
        actions: {
          applySavedAddress: applySavedRecipientAddress,
        },
      });
      return savedAddressController;
    }

    var cartUi = ensureUiController();
    cartUi.bindMethodCards();
    cartUi.bindTimeslotTypeCards();
    cartUi.bindFormInputs();
    on(document, 'wf:cart:message-saved', function () {
      cartUi.syncMethodCards();
      updateAfterPostalVisibility();
      updateRecipientVisibility();
      updateTimeslotTypeVisibility();
      updateTimeslotLockState();
      validateAndBlockCheckout();
    });

    var checkoutFlow = ensureCheckoutFlowController();
    bindCartFormKeyboardSubmitGuard(document.getElementById('cart_form'), wrap);

    var ldCheckoutBtn = document.getElementById('wf-ld-checkout');
    if (ldCheckoutBtn) {
      var cartForm = document.getElementById('cart_form');
      if (cartForm && cartForm.contains(ldCheckoutBtn)) {
        var checkoutWrap = ldCheckoutBtn.closest('.cart__price-breakdown') || ldCheckoutBtn.parentNode;
        cartForm.parentNode.insertBefore(checkoutWrap, cartForm.nextSibling);
      }

      on(ldCheckoutBtn, 'click', function () {
        if (!config) return;
        ensureAddressConsistencyBeforeCheckout(function (ok) {
          if (!ok) return;
          proceedLdCheckout();
        });
      });

      function proceedLdCheckout() {
        updateAttributes();
        var idleCheckoutLabel = ldCheckoutBtn.getAttribute('data-wf-ld-idle-label') || ldCheckoutBtn.textContent || 'Checkout';
        if (!ldCheckoutBtn.getAttribute('data-wf-ld-idle-label')) {
          ldCheckoutBtn.setAttribute('data-wf-ld-idle-label', idleCheckoutLabel);
        }
        ldCheckoutBtn.disabled = true;
        ldCheckoutBtn.textContent = 'Processing...';

        var MSG = window.WF_CART_LINE_MESSAGES;
        var msgPromise = (MSG && typeof MSG.prepareMessagesForCheckout === 'function')
          ? MSG.prepareMessagesForCheckout()
          : ((MSG && typeof MSG.saveAllUnsavedMessages === 'function')
              ? MSG.saveAllUnsavedMessages().then(function () { return { ok: true }; })
              : Promise.resolve({ ok: true }));

        msgPromise.then(function (messageState) {
          if (messageState && messageState.ok === false) {
            var messageHint = getEl('wf-ld-checkout-hint');
            if (messageHint && messageState.message) {
              messageHint.textContent = messageState.message;
              messageHint.style.display = 'block';
            }
            ldCheckoutBtn.disabled = false;
            ldCheckoutBtn.textContent = idleCheckoutLabel;
            if (typeof ldCheckoutBtn.removeAttribute === 'function') ldCheckoutBtn.removeAttribute('aria-busy');
            return;
          }

          var UPSELL = window.WF_LD_UPSELL;
          console.log('[wf-ld] UPSELL exists?', !!UPSELL, 'isEnabled?', UPSELL && UPSELL.isEnabled());
          if (UPSELL && UPSELL.isEnabled() && typeof UPSELL.shouldShowForCart === 'function') {
            UPSELL.shouldShowForCart()
              .then(function (shouldShow) {
                if (shouldShow) {
                  console.log('[wf-ld] showing upsell modal');
                  UPSELL.show(function () { checkoutFlow.proceedToCheckout(ldCheckoutBtn); });
                  return;
                }
                console.log('[wf-ld] upsell tag gate skipped modal');
                checkoutFlow.proceedToCheckout(ldCheckoutBtn);
              })
              .catch(function (err) {
                console.warn('[wf-ld] upsell tag gate check failed, proceeding', err);
                checkoutFlow.proceedToCheckout(ldCheckoutBtn);
              });
          } else if (UPSELL && UPSELL.isEnabled()) {
            console.log('[wf-ld] showing upsell modal');
            UPSELL.show(function () { checkoutFlow.proceedToCheckout(ldCheckoutBtn); });
          } else {
            console.log('[wf-ld] skipping upsell, proceeding to checkout');
            checkoutFlow.proceedToCheckout(ldCheckoutBtn);
          }
        }).catch(function (err) {
          console.error('[wf-ld] message-card checkout preparation failed', err);
          var messageHint = getEl('wf-ld-checkout-hint');
          if (messageHint) {
            messageHint.textContent = 'We could not prepare your message card updates. Please try again.';
            messageHint.style.display = 'block';
          }
          ldCheckoutBtn.disabled = false;
          ldCheckoutBtn.textContent = idleCheckoutLabel;
          if (typeof ldCheckoutBtn.removeAttribute === 'function') ldCheckoutBtn.removeAttribute('aria-busy');
        });
      }
    }

    restoreState();
    syncPhoneHidden();
    cartUi.syncMethodCards();
    updateAfterPostalVisibility();
    updateRecipientAddressSummary();
    updateRecipientVisibility();
    updateTimeslotTypeVisibility();
    refreshAdvanceBookingState();
    updateTimeslotLockState();
    updateExpressCardLabel();
    updateStandardCardLabel();
    ensureSavedAddressController();

    if (ADDRESS_AC && config.google_maps_key) {
      ADDRESS_AC.loadScript(config.google_maps_key);
      var acStreet = wrap.querySelector('[name="attributes[recipient_address1]"]');
      var acUnit = wrap.querySelector('[name="attributes[recipient_address2]"]');
      var acPostal = wrap.querySelector('[name="attributes[recipient_postal]"]');
      ADDRESS_AC.init(acStreet, acPostal, acUnit, {
        onPlaceApplyStart: function () {
          recipientAutocompleteApplying = true;
        },
        onPlaceApplyEnd: function (filledCode) {
          recipientAutocompleteApplying = false;
          clearAddressConsistencyHint();
          var code = String(filledCode || '').trim();
          if (code.length === 6) {
            validatePostalServer(code);
          }
          onChange();
        },
        onPostalPlaceApplyStart: function () {
          recipientAutocompleteApplying = true;
        },
        onPostalPlaceApplyEnd: function (filledCode) {
          recipientAutocompleteApplying = false;
          clearAddressConsistencyHint();
          var code = String(filledCode || '').trim();
          if (code.length === 6) {
            validatePostalServer(code);
          }
          updateRecipientAddressSummary();
          onChange();
        },
      });
    }

    if (EXPRESS.removeAllFeeProducts || EXPRESS.removeAllExpressProducts) {
      var resetPromise = EXPRESS.removeAllFeeProducts
        ? EXPRESS.removeAllFeeProducts()
        : EXPRESS.removeAllExpressProducts();
      resetPromise.then(function () {
        EXPRESS.refreshCartTotals();
        if (EXPRESS.setFeeChargeVisible) EXPRESS.setFeeChargeVisible(false);
        else if (EXPRESS.setExpressChargeVisible) EXPRESS.setExpressChargeVisible(false);
        setDeliveryFeeRow('Delivery Fee', null);
      });
    }

    validateAndBlockCheckout();
  }

    function disposeMixedCartObservers() {
      if (mixedCartObserver) {
        mixedCartObserver.disconnect();
        mixedCartObserver = null;
      }
      if (mixedCartVisibilityHandler) {
        document.removeEventListener('visibilitychange', mixedCartVisibilityHandler);
        mixedCartVisibilityHandler = null;
      }
    }

    return {
      init: init,
      startMixedCartObservers: startMixedCartObservers,
      disposeMixedCartObservers: disposeMixedCartObservers,
    };
  }

  window.WF_LD_CART_INIT = {
    createInitController: createInitController,
    _test: {
      isKeyboardSubmitProneField: isKeyboardSubmitProneField,
      getDeliveryPostalCodeFromInput: getDeliveryPostalCodeFromInput,
      resolveMappedPricingTierId: resolveMappedPricingTierId,
      isDeliveryAddressGateReady: isDeliveryAddressGateReady,
    },
  };
})();
